// extracted by mini-css-extract-plugin
export default {"buttonWrapper":"button-module--buttonWrapper--165a2"};